import React from 'react';
import { isNumber } from 'vdlib';
import { I18n as I } from 'react-redux-i18n';

const FormHelper = {
  isPositiveNumber: obj => isNumber(obj) && obj > 0,
};

const useYupValidator = validationSchema => {
  return React.useCallback(
    (keyOrData, value) => {
      try {
        // validate single field
        if (typeof keyOrData === 'string') {
          validationSchema.validateSyncAt(
            keyOrData,
            { [keyOrData]: value },
            {
              abortEarly: false,
            }
          );
        } else {
          //validate whole schema
          validationSchema.validateSync(keyOrData, {
            abortEarly: false,
          });
        }
      } catch (validationEx) {
        return validationEx.inner.reduce((obj, { message, path }) => {
          obj[path] = I.t(message) || message;
          return obj;
        }, {});
      }
      return {};
    },
    [validationSchema]
  );
};

export { useYupValidator };

export default FormHelper;
